import loadable from '@loadable/component';
import React from 'react';
import { normalizeHref } from 'wix-rich-content-common';
import { Decoration_Type } from 'ricos-schema';
import classNames from 'classnames';

var EXTERNAL_LINK_TYPE = "wix-draft-plugin-external-link";
var LINK_TYPE = "LINK";
var ANCHOR_TYPE = "ANCHOR";
var CUSTOM_LINK_TYPE = "ricos-plugin-custom-link";

var typeMapper = function typeMapper() {
  var _ref;
  return _ref = {}, _ref[EXTERNAL_LINK_TYPE] = {
    component: loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "LinkViewer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "LinkViewer" */'./LinkViewer.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./LinkViewer");
        }
        return eval('require.resolve')("./LinkViewer");
      }
    }),
    elementType: "inline"
  }, _ref[LINK_TYPE] = {
    component: loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "LinkViewer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "LinkViewer" */'./LinkViewer.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./LinkViewer");
        }
        return eval('require.resolve')("./LinkViewer");
      }
    }),
    elementType: "inline"
  }, _ref[ANCHOR_TYPE] = {
    component: loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "LinkViewer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "LinkViewer" */'./LinkViewer.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./LinkViewer");
        }
        return eval('require.resolve')("./LinkViewer");
      }
    }),
    elementType: "inline"
  }, _ref[CUSTOM_LINK_TYPE] = {
    component: loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "LinkViewer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "LinkViewer" */'./LinkViewer.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./LinkViewer");
        }
        return eval('require.resolve')("./LinkViewer");
      }
    }),
    elementType: "inline"
  }, _ref;
};

var DEFAULTS = {
  config: {
    linkTypes: {
      anchor: true
    }
  }
};

var styles = {"fontElementMap":"I1hhl","link":"TWoY9","linkInEditor":"AagAZ","linkInViewer":"itht3","toolbarUrlContainer":"yO1xz","toolbarUrl":"ye8bm","toolbarUrlAnchor":"jp1Db"};

var decorator$1 = function decorator(element, linkDecoration, contextualData) {
  var _a;
  var _linkDecoration$linkD = linkDecoration.linkData.link;
  _linkDecoration$linkD = _linkDecoration$linkD === void 0 ? {} : _linkDecoration$linkD;
  var url = _linkDecoration$linkD.url,
    _linkDecoration$linkD2 = _linkDecoration$linkD.target,
    target = _linkDecoration$linkD2 === void 0 ? contextualData.anchorTarget : _linkDecoration$linkD2,
    _linkDecoration$linkD3 = _linkDecoration$linkD.rel,
    rel = _linkDecoration$linkD3 === void 0 ? {} : _linkDecoration$linkD3;
  var relValue = "noopener";
  rel.nofollow && (relValue += " nofollow");
  rel.sponsored && (relValue += " sponsored");
  rel.ugc && (relValue += " ugc");
  (rel.noreferrer || rel.noreferrer === void 0) && (relValue += " noreferrer");
  return /* @__PURE__ */React.createElement("a", {
    key: "link=" + element.key,
    target: "_" + ((_a = target == null ? void 0 : target.toLowerCase) == null ? void 0 : _a.call(target)),
    href: url && normalizeHref(url),
    rel: relValue,
    className: classNames(styles.link, styles.linkInViewer)
  }, element);
};
var LinkDecorator = {
  rule: function rule(node) {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(function (_ref) {
      var type = _ref.type;
      return type === Decoration_Type.LINK;
    }));
  },
  decorate: function decorate(_ref2) {
    var element = _ref2.element,
      node = _ref2.node,
      context = _ref2.context;
    var _a, _b;
    var linkDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(function (_ref3) {
      var type = _ref3.type;
      return type === Decoration_Type.LINK;
    });
    return decorator$1(element, linkDecoration, context);
  }
};

var decorator = function decorator(anchorDecoration, element) {
  var anchor = anchorDecoration.anchorData.anchor;
  return /* @__PURE__ */React.createElement("a", {
    key: "anchor-" + (element == null ? void 0 : element.key),
    target: "_self",
    href: "#viewer-" + anchor,
    className: classNames(styles.link, styles.linkInViewer)
  }, element);
};
var AnchorDecorator = {
  rule: function rule(node) {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(function (_ref) {
      var type = _ref.type;
      return type === Decoration_Type.ANCHOR;
    }));
  },
  decorate: function decorate(_ref2) {
    var element = _ref2.element,
      node = _ref2.node;
    var _a, _b;
    var anchorDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(function (_ref3) {
      var type = _ref3.type;
      return type === Decoration_Type.ANCHOR;
    });
    return decorator(anchorDecoration, element);
  }
};

var nodeViewDecorators = [LinkDecorator, AnchorDecorator];

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginLink = function pluginLink(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINK_TYPE,
    typeMapper: typeMapper,
    nodeViewDecorators: nodeViewDecorators
  };
};

export { LINK_TYPE as L, pluginLink as p, styles as s, typeMapper as t };
